// Estado global del formulario
const state = {
  lat: null,
  lng: null,
  zone: null,
  address: '',
  addressComponents: {
    street: '',
    city: '',
    stateName: '',
    postalCode: '',
  },
  suggestedProduct: null,
  suggestedProductName: null,
  suggestedProductPrice: null,
  leadId: null,
  customer: null,
  deviceSessionId: null,
  config: { quiz: [], products: [], notify: { fields: [] } },
}

// ─── Hidratación de config dinámica desde /api/form-config ───────────────────

function formatMoney(value) {
  const n = Number(value) || 0
  return '$' + n.toLocaleString('es-MX') + ' MXN/mes'
}

function findProduct(productId) {
  return (state.config.products || []).find((p) => p.productId === productId) || null
}

function applyAppSettings(notify) {
  if (!notify) return
  const setText = (id, text) => {
    const el = document.getElementById(id)
    if (el && text) el.textContent = text
  }
  setText('notify-title', notify.title)
  setText('notify-subtitle', notify.subtitle)
  const success = document.getElementById('notify-success')
  if (success && notify.successMessage) success.textContent = notify.successMessage
}

function hydrateQuiz(questions) {
  const form = document.getElementById('form-quiz')
  if (!form) return
  if (!questions.length) {
    form.innerHTML = '<p class="pureit-subtitle">No hay preguntas configuradas. Crea algunas en el panel admin.</p>'
    return
  }
  const fields = questions.map((q) => `
    <div class="pureit-field">
      <label for="quiz-${q.key}" class="pureit-field-hint">${q.label}</label>
      <select id="quiz-${q.key}" data-question="${q.label.replace(/"/g, '&quot;')}" class="pureit-input" required>
        <option value="">Selecciona...</option>
        ${q.options.map((o) => `<option value="${o}">${o}</option>`).join('')}
      </select>
    </div>
  `).join('')
  form.innerHTML = fields + '<button type="submit" class="pureit-btn-primary">Ver mi recomendación</button>'
}

function hydrateNotifyForm(notify) {
  const form = document.getElementById('form-notify-me')
  if (!form) return
  // Campos fijos siempre presentes
  const baseFields = [
    { key: 'notify-name',  label: 'Nombre',   type: 'text',  required: true },
    { key: 'notify-email', label: 'Email',    type: 'email', required: true },
    { key: 'notify-phone', label: 'Teléfono', type: 'tel',   required: true },
  ]
  const extraFields = (notify?.fields || []).map((f) => ({
    key: 'notify-extra-' + f.key,
    dataKey: f.key,
    label: f.label,
    type: f.type,
    required: f.required,
    options: f.options || [],
  }))
  const all = [...baseFields, ...extraFields]

  const renderField = (f) => {
    const req = f.required ? 'required' : ''
    let input
    if (f.type === 'textarea') {
      input = `<textarea id="${f.key}" class="pureit-input" ${req}></textarea>`
    } else if (f.type === 'select') {
      input = `<select id="${f.key}" class="pureit-input" ${req}>
        <option value="">Selecciona...</option>
        ${f.options.map((o) => `<option value="${o}">${o}</option>`).join('')}
      </select>`
    } else {
      input = `<input type="${f.type}" id="${f.key}" placeholder="${f.label}" class="pureit-input" ${req} />`
    }
    return `<div class="pureit-field">${input}<label for="${f.key}" class="pureit-field-hint">${f.label}</label></div>`
  }

  const buttonLabel = (typeof PUREIT_FORM_NOTIFY_BUTTON !== 'undefined' && PUREIT_FORM_NOTIFY_BUTTON) || 'Notifícame'
  form.innerHTML = all.map(renderField).join('') + `<button type="submit" class="pureit-btn-primary">${buttonLabel}</button>`

  // Guardar lista de campos extra para serializarlos en submit
  state.notifyExtraFields = extraFields
}

function loadFormConfig() {
  return fetch(`${BACKEND_URL}/api/form-config`)
    .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json() })
    .then((cfg) => {
      state.config = cfg
      window.PUREIT_FORM_NOTIFY_BUTTON = cfg.notify?.buttonLabel
      applyAppSettings(cfg.notify)
      hydrateQuiz(cfg.quiz || [])
      hydrateNotifyForm(cfg.notify || { fields: [] })
    })
    .catch((err) => {
      console.error('[form-config]', err)
    })
}

let map, marker, autocomplete

// ─── Loading helpers ─────────────────────────────────────────────────────────

function setLoading(btn, loading, loadingText) {
  if (loading) {
    btn.disabled = true
    btn.dataset.originalText = btn.textContent
    btn.innerHTML = `<span class="pureit-spinner"></span>${loadingText}`
    btn.classList.add('pureit-btn--loading')
  } else {
    btn.disabled = false
    btn.textContent = btn.dataset.originalText
    btn.classList.remove('pureit-btn--loading')
  }
}

// ─── OpenPay setup ───────────────────────────────────────────────────────────

const PAYMENT_ERROR_MSG = 'El pago fue rechazado, intenta de nuevo o usa otro método de pago.'

const OPENPAY_ERRORS = {
  2004: PAYMENT_ERROR_MSG,
  2005: PAYMENT_ERROR_MSG,
  2006: PAYMENT_ERROR_MSG,
  3001: PAYMENT_ERROR_MSG,
  3002: PAYMENT_ERROR_MSG,
  3003: PAYMENT_ERROR_MSG,
  3004: PAYMENT_ERROR_MSG,
  3005: PAYMENT_ERROR_MSG,
  3006: PAYMENT_ERROR_MSG,
  3009: PAYMENT_ERROR_MSG,
  3010: PAYMENT_ERROR_MSG,
  3011: PAYMENT_ERROR_MSG,
  3012: PAYMENT_ERROR_MSG,
}

function initOpenPay() {
  if (typeof OpenPay === 'undefined') return false
  if (!OPENPAY_CONFIG.merchantId || !OPENPAY_CONFIG.publicKey) return false
  OpenPay.setId(OPENPAY_CONFIG.merchantId)
  OpenPay.setApiKey(OPENPAY_CONFIG.publicKey)
  OpenPay.setSandboxMode(Boolean(OPENPAY_CONFIG.sandbox))
  state.deviceSessionId = OpenPay.deviceData.setup()
  return true
}

function validateCardClientSide(cardData) {
  const fields = {
    'card-number': OpenPay.card.validateCardNumber(cardData.card_number),
    'card-month':  OpenPay.card.validateExpiry(cardData.expiration_month, cardData.expiration_year),
    'card-cvv':    OpenPay.card.validateCVC(cardData.cvv2, cardData.card_number),
  }
  let firstError = null
  for (const [id, ok] of Object.entries(fields)) {
    const el = document.getElementById(id)
    el.classList.toggle('input-error', !ok)
    el.classList.toggle('input-valid', ok)
    if (!ok && !firstError) {
      firstError = PAYMENT_ERROR_MSG
    }
  }
  return firstError
}

// ─── Google Maps ──────────────────────────────────────────────────────────────

window.mapLoadError = function mapLoadError() {
  document.getElementById('map-loading').classList.add('pureit-hidden')
  document.getElementById('map-error').classList.remove('pureit-hidden')
}

window.gm_authFailure = function() {
  mapLoadError()
}

document.getElementById('btn-retry-map')?.addEventListener('click', () => {
  window.location.reload()
})

window.initMap = async function initMap() {
  document.getElementById('map-loading').classList.add('pureit-hidden')

  const { Map }          = await google.maps.importLibrary('maps')
  const { Autocomplete } = await google.maps.importLibrary('places')

  // AdvancedMarkerElement requiere mapId. Sin él, caemos al Marker clásico.
  const hasMapId = !!(typeof MAP_ID !== 'undefined' && MAP_ID)

  map = new Map(document.getElementById('map'), {
    center: { lat: 19.4326, lng: -99.1332 },
    zoom: 11,
    ...(hasMapId ? { mapId: MAP_ID } : {}),
  })

  if (hasMapId) {
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')
    marker = new AdvancedMarkerElement({ map, gmpDraggable: true })
    marker.addListener('dragend', (event) => {
      const lat = event.latLng?.lat?.() ?? marker.position?.lat
      const lng = event.latLng?.lng?.() ?? marker.position?.lng
      if (typeof lat !== 'number' || typeof lng !== 'number') return
      setLocationFromCoords(lat, lng)
    })
  } else {
    // Fallback: marker clásico (deprecated pero soportado).
    marker = new google.maps.Marker({ map, draggable: true })
    marker.addListener('dragend', () => {
      const pos = marker.getPosition()
      if (!pos) return
      setLocationFromCoords(pos.lat(), pos.lng())
    })
    console.warn('[pureit] MAP_ID no configurado; usando google.maps.Marker (deprecated). Crea un Map ID en Google Cloud Console y configúralo en el setting "Google Maps Map ID" de la sección Liquid.')
  }

  autocomplete = new Autocomplete(
    document.getElementById('address-input'),
    { componentRestrictions: { country: 'mx' } }
  )

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace()
    if (!place.geometry) return
    const lat = place.geometry.location.lat()
    const lng = place.geometry.location.lng()
    placeMarker(lat, lng, place.formatted_address)
    parseAddressComponents(place.address_components || [])
    verifyCoverage(lat, lng, place.formatted_address)
  })

  // Si el cliente está logueado y tiene dirección por defecto, pre-cargarla y verificar cobertura.
  if (typeof PUREIT_CUSTOMER !== 'undefined' && PUREIT_CUSTOMER && PUREIT_CUSTOMER.defaultAddress) {
    const addr = PUREIT_CUSTOMER.defaultAddress
    const fullAddress = [addr.address1, addr.address2, addr.city, addr.province, addr.zip, addr.country]
      .filter(Boolean)
      .join(', ')
    if (fullAddress) {
      document.getElementById('address-input').value = fullAddress
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: fullAddress, componentRestrictions: { country: 'mx' } }, (results, status) => {
        if (status !== 'OK' || !results[0]) return
        const lat = results[0].geometry.location.lat()
        const lng = results[0].geometry.location.lng()
        placeMarker(lat, lng, results[0].formatted_address)
        parseAddressComponents(results[0].address_components || [])
        verifyCoverage(lat, lng, results[0].formatted_address)
      })
    }
  }
}

function setLocationFromCoords(lat, lng) {
  const geocoder = new google.maps.Geocoder()
  geocoder.geocode({ location: { lat, lng } }, (results, status) => {
    if (status === 'OK' && results[0]) {
      const address = results[0].formatted_address
      document.getElementById('address-input').value = address
      placeMarker(lat, lng, address)
      parseAddressComponents(results[0].address_components || [])
      verifyCoverage(lat, lng, address)
    } else {
      placeMarker(lat, lng, '')
      verifyCoverage(lat, lng, '')
    }
  })
}

function placeMarker(lat, lng, address) {
  state.lat = lat
  state.lng = lng
  state.address = address || ''
  if (typeof marker.setPosition === 'function') {
    marker.setPosition({ lat, lng })
  } else {
    marker.position = { lat, lng }
  }
  map.panTo({ lat, lng })
  map.setZoom(14)
}

function parseAddressComponents(components) {
  const get = (type) => {
    const c = components.find((c) => c.types.includes(type))
    return c ? c.long_name : ''
  }
  const streetNumber = get('street_number')
  const route        = get('route')
  const neighborhood = get('sublocality_level_1') || get('neighborhood')
  state.addressComponents = {
    street:       [route, streetNumber].filter(Boolean).join(' '),
    neighborhood,
    city:         get('locality') || get('administrative_area_level_2'),
    stateName:    get('administrative_area_level_1'),
    postalCode:   get('postal_code'),
  }
}

// ─── Detectar ubicación ───────────────────────────────────────────────────────

document.getElementById('btn-detect')?.addEventListener('click', () => {
  if (!navigator.geolocation) {
    alert('Tu navegador no soporta geolocalización.')
    return
  }
  const btn = document.getElementById('btn-detect')
  setLoading(btn, true, 'Detectando...')

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      setLoading(btn, false)
      setLocationFromCoords(pos.coords.latitude, pos.coords.longitude)
    },
    () => {
      setLoading(btn, false)
      alert('No se pudo obtener tu ubicación. Verifica los permisos del navegador.')
    }
  )
})

// ─── Verificar cobertura ──────────────────────────────────────────────────────

async function verifyCoverage(lat, lng, address) {
  const res = await fetch(`${BACKEND_URL}/api/check-coverage`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lat, lng }),
  })
  const data = await res.json()

  state.zone    = data.zone
  state.address = address

  document.getElementById('coverage-result').classList.remove('pureit-hidden')
  document.getElementById('coverage-ok').classList.add('pureit-hidden')
  document.getElementById('coverage-out').classList.add('pureit-hidden')

  if (data.inCoverage) {
    document.getElementById('coverage-ok').classList.remove('pureit-hidden')
  } else {
    document.getElementById('coverage-out').classList.remove('pureit-hidden')
  }
}

// ─── Formulario fuera de rango ────────────────────────────────────────────────

document.getElementById('form-notify-me')?.addEventListener('submit', async (e) => {
  e.preventDefault()
  const btn = e.submitter
  setLoading(btn, true, 'Enviando...')

  const extraData = {}
  for (const f of state.notifyExtraFields || []) {
    const el = document.getElementById(f.key)
    if (el && el.value) extraData[f.dataKey] = el.value
  }

  const body = {
    name:    document.getElementById('notify-name').value,
    email:   document.getElementById('notify-email').value,
    phone:   document.getElementById('notify-phone').value,
    address: state.address,
    lat:     state.lat,
    lng:     state.lng,
    ...(Object.keys(extraData).length > 0 ? { extraData } : {}),
  }

  try {
    const res = await fetch(`${BACKEND_URL}/api/notify-me`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    if (res.ok) {
      document.getElementById('form-notify-me').classList.add('pureit-hidden')
      document.getElementById('notify-success').classList.remove('pureit-hidden')
    }
  } finally {
    setLoading(btn, false)
  }
})

// ─── Ir al quiz ───────────────────────────────────────────────────────────────

document.getElementById('btn-go-quiz')?.addEventListener('click', () => {
  showStep('step-2')
})

// ─── Quiz → sugerencia ────────────────────────────────────────────────────────

document.getElementById('form-quiz')?.addEventListener('submit', async (e) => {
  e.preventDefault()
  const btn = e.submitter
  setLoading(btn, true, 'Analizando tus respuestas...')

  const answers = Array.from(document.querySelectorAll('#form-quiz select[data-question]'))
    .map((el) => ({ question: el.dataset.question, value: el.value }))
    .filter((a) => a.value)

  state.lastAnswers = answers

  try {
    const res = await fetch(`${BACKEND_URL}/api/suggest-product`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ answers }),
    })
    const data = await res.json()

    state.suggestedProduct     = data.productId
    state.suggestedProductName = data.productName

    const product = findProduct(data.productId)
    state.suggestedProductPrice = product ? product.price : null

    document.getElementById('suggestion-product').textContent = data.productName
    document.getElementById('suggestion-reason').textContent  = data.reason
    const priceEl = document.getElementById('suggestion-price')
    if (priceEl) priceEl.textContent = product ? formatMoney(product.price) : ''
    document.getElementById('form-quiz').classList.add('pureit-hidden')
    document.getElementById('suggestion-result').classList.remove('pureit-hidden')
  } finally {
    setLoading(btn, false)
  }
})

function escapeHtml(s) {
  return String(s || '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]))
}

function safeImgSrc(url) {
  // Solo aceptar http(s) — bloquea javascript:, data:, etc.
  if (!url) return ''
  try {
    const parsed = new URL(url, window.location.origin)
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return ''
    return parsed.href
  } catch {
    return ''
  }
}

function renderProductsCatalog() {
  const list = document.getElementById('products-list')
  if (!list) return
  const products = state.config.products || []
  if (!products.length) {
    list.textContent = 'No hay productos configurados.'
    return
  }
  list.innerHTML = products.map((p) => {
    const img = safeImgSrc(p.imageUrl)
    return `
      <div class="pureit-product-card">
        ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(p.name)}" class="pureit-product-card__img">` : ''}
        <h4 class="pureit-product-card__name">${escapeHtml(p.name)}</h4>
        <p class="pureit-product-card__price">${escapeHtml(formatMoney(p.price))}</p>
        <p class="pureit-product-card__desc">${escapeHtml(p.description)}</p>
        <button type="button" class="pureit-btn-primary" data-action="select-product" data-id="${escapeHtml(p.productId)}">Elegir este</button>
      </div>
    `
  }).join('')
  list.querySelectorAll('[data-action="select-product"]').forEach((btn) => {
    btn.addEventListener('click', () => selectProductFromCatalog(btn.dataset.id))
  })
}

function selectProductFromCatalog(productId) {
  const product = findProduct(productId)
  if (!product) return
  state.suggestedProduct = product.productId
  state.suggestedProductName = product.name
  state.suggestedProductPrice = product.price
  // Reusa el flujo existente de "ir al checkout"
  document.getElementById('btn-go-checkout').click()
}

document.getElementById('btn-show-catalog')?.addEventListener('click', () => {
  renderProductsCatalog()
  document.getElementById('suggestion-result').classList.add('pureit-hidden')
  document.getElementById('products-catalog').classList.remove('pureit-hidden')
})

document.getElementById('btn-back-to-suggestion')?.addEventListener('click', () => {
  document.getElementById('products-catalog').classList.add('pureit-hidden')
  document.getElementById('suggestion-result').classList.remove('pureit-hidden')
})

// ─── Paso 3: Verificar o registrar cuenta (solo invitados) ───────────────────

document.getElementById('btn-has-account')?.addEventListener('click', () => {
  showAccountPanel('account-login')
})

document.getElementById('btn-no-account')?.addEventListener('click', () => {
  showAccountPanel('account-register')
})

document.getElementById('btn-back-from-question')?.addEventListener('click', () => {
  showStep('step-2')
})

document.getElementById('btn-back-from-login')?.addEventListener('click', () => {
  showAccountPanel('account-question')
})

document.getElementById('btn-back-from-register')?.addEventListener('click', () => {
  showAccountPanel('account-question')
})

document.getElementById('btn-goto-register')?.addEventListener('click', () => {
  const email = document.getElementById('login-email')?.value?.trim()
  showAccountPanel('account-register')
  if (email) {
    const regEmail = document.getElementById('reg-email')
    if (regEmail) regEmail.value = email
  }
})

document.getElementById('btn-goto-login')?.addEventListener('click', () => {
  const email = document.getElementById('reg-email')?.value?.trim()
  showAccountPanel('account-login')
  if (email) {
    const loginEmail = document.getElementById('login-email')
    if (loginEmail) loginEmail.value = email
  }
})

document.getElementById('btn-verify-account')?.addEventListener('click', async () => {
  const btn      = document.getElementById('btn-verify-account')
  const email    = document.getElementById('login-email')?.value?.trim()
  const errorEl  = document.getElementById('login-error')
  const errorMsg = document.getElementById('login-error-msg')

  errorEl?.classList.add('pureit-hidden')
  document.getElementById('btn-goto-register')?.classList.add('pureit-hidden')

  if (!email) {
    errorMsg.textContent = 'Ingresa tu correo electrónico.'
    errorEl?.classList.remove('pureit-hidden')
    return
  }

  setLoading(btn, true, 'Verificando...')
  try {
    const res  = await fetch(`${BACKEND_URL}/api/check-account`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
    const data = await res.json()

    if (!data.exists) {
      errorMsg.textContent = 'No encontramos una cuenta con ese correo.'
      document.getElementById('btn-goto-register')?.classList.remove('pureit-hidden')
      errorEl?.classList.remove('pureit-hidden')
      return
    }

    // La cuenta existe: se exige iniciar sesión en Shopify (no basta con conocer el correo).
    // Al volver, PUREIT_CUSTOMER ya viene poblado y el formulario salta este paso.
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search)
    window.location.href = `${ACCOUNT_LOGIN_URL}?return_url=${returnUrl}`
    return
  } catch {
    errorMsg.textContent = 'Ocurrió un error al verificar tu cuenta. Intenta de nuevo.'
    errorEl?.classList.remove('pureit-hidden')
  } finally {
    setLoading(btn, false)
  }
})

document.getElementById('form-register')?.addEventListener('submit', async (e) => {
  e.preventDefault()
  const btn      = e.submitter
  const errorEl  = document.getElementById('register-error')
  const errorMsg = document.getElementById('register-error-msg')

  errorEl?.classList.add('pureit-hidden')
  document.getElementById('btn-goto-login')?.classList.add('pureit-hidden')

  const firstName = document.getElementById('reg-firstname')?.value?.trim() ?? ''
  const lastName  = document.getElementById('reg-lastname')?.value?.trim()  ?? ''
  const email     = document.getElementById('reg-email')?.value?.trim()     ?? ''
  const password  = document.getElementById('reg-password')?.value          ?? ''

  if (password.length < 5) {
    errorMsg.textContent = 'La contraseña debe tener al menos 5 caracteres.'
    errorEl?.classList.remove('pureit-hidden')
    return
  }

  setLoading(btn, true, 'Creando cuenta...')
  try {
    const res  = await fetch(`${BACKEND_URL}/api/register-account`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, firstName, lastName, password }),
    })
    const data = await res.json()

    if (!res.ok) {
      if (res.status === 409) {
        errorMsg.textContent = 'Este correo ya está registrado.'
        document.getElementById('btn-goto-login')?.classList.remove('pureit-hidden')
      } else {
        errorMsg.textContent = data?.message || 'No pudimos crear tu cuenta. Intenta de nuevo.'
      }
      errorEl?.classList.remove('pureit-hidden')
      return
    }

    goToCheckoutStep({ email, firstName, lastName, shopifyCustomerId: data.customerId })
  } catch {
    errorMsg.textContent = 'Ocurrió un error al crear tu cuenta. Intenta de nuevo.'
    errorEl?.classList.remove('pureit-hidden')
  } finally {
    setLoading(btn, false)
  }
})

function showAccountPanel(panelId) {
  ;['account-question', 'account-login', 'account-register'].forEach((id) => {
    document.getElementById(id)?.classList.toggle('pureit-hidden', id !== panelId)
  })
  document.getElementById('btn-goto-register')?.classList.add('pureit-hidden')
  document.getElementById('btn-goto-login')?.classList.add('pureit-hidden')
}

function goToCheckoutStep(accountData) {
  state.accountData = accountData

  const isLoggedIn = !!(typeof PUREIT_CUSTOMER !== 'undefined' && PUREIT_CUSTOMER)
  const step4BackBtn = document.querySelector('#step-4 .pureit-btn-back')
  if (step4BackBtn) step4BackBtn.dataset.back = isLoggedIn ? 'step-2' : 'step-3'

  showStep('step-4')
  const { street, neighborhood, city, stateName, postalCode } = state.addressComponents
  document.getElementById('co-product-name').textContent = state.suggestedProductName || ''
  document.getElementById('co-address').value = [street, neighborhood].filter(Boolean).join(', ') || state.address
  document.getElementById('co-city').value    = city       || ''
  document.getElementById('co-state').value   = stateName  || ''
  document.getElementById('co-cp').value      = postalCode || ''

  const emailEl    = document.getElementById('co-email')
  const nameEl     = document.getElementById('co-name')
  const lastNameEl = document.getElementById('co-lastname')
  const phoneEl    = document.getElementById('co-phone')

  if (emailEl)    { emailEl.value    = accountData.email;     emailEl.disabled    = true }
  if (nameEl)     { nameEl.value     = accountData.firstName; nameEl.disabled     = false }
  if (lastNameEl) { lastNameEl.value = accountData.lastName;  lastNameEl.disabled = false }
  if (phoneEl && !phoneEl.value && accountData.phone) phoneEl.value = accountData.phone

  state.initialCheckoutAddress = getCheckoutAddressKey()
}

document.getElementById('btn-go-checkout')?.addEventListener('click', () => {
  const isGuest = !(typeof PUREIT_CUSTOMER !== 'undefined' && PUREIT_CUSTOMER)
  if (isGuest) {
    showStep('step-3')
    showAccountPanel('account-question')
  } else {
    goToCheckoutStep({
      email:             PUREIT_CUSTOMER.email,
      firstName:         PUREIT_CUSTOMER.firstName,
      lastName:          PUREIT_CUSTOMER.lastName,
      phone:             PUREIT_CUSTOMER.phone,
      shopifyCustomerId: String(PUREIT_CUSTOMER.id),
    })
  }
})

function getCheckoutAddressKey() {
  return [
    document.getElementById('co-address').value,
    document.getElementById('co-city').value,
    document.getElementById('co-state').value,
    document.getElementById('co-cp').value,
  ].map((v) => v.trim().toLowerCase()).join('|')
}

function geocodeAddress(addressString) {
  return new Promise((resolve) => {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode(
      { address: addressString, componentRestrictions: { country: 'MX' } },
      (results, status) => {
        if (status !== 'OK' || !results[0]) return resolve(null)
        const result = results[0]
        const get = (type) => {
          const c = (result.address_components || []).find((c) => c.types.includes(type))
          return c ? c.long_name : ''
        }
        resolve({
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
          city: get('locality') || get('administrative_area_level_2'),
          state: get('administrative_area_level_1'),
          postalCode: get('postal_code'),
          formattedAddress: result.formatted_address,
        })
      }
    )
  })
}

const DIACRITICS_RE = new RegExp('[\\u0300-\\u036f]', 'g')

function normalizeText(s) {
  return (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(DIACRITICS_RE, '')
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, ' ')
}

function showCheckoutError(msg) {
  document.getElementById('checkout-error-msg').textContent = msg
  document.getElementById('checkout-error')?.classList.remove('pureit-hidden')
}

function hideCheckoutError() {
  document.getElementById('checkout-error')?.classList.add('pureit-hidden')
}

async function revalidateCheckoutAddress() {
  const address    = document.getElementById('co-address').value.trim()
  const city       = document.getElementById('co-city').value.trim()
  const stateName  = document.getElementById('co-state').value.trim()
  const postalCode = document.getElementById('co-cp').value.trim()

  if (!/^\d{5}$/.test(postalCode)) {
    showCheckoutError('El código postal debe tener exactamente 5 dígitos.')
    return false
  }

  const fullAddress = [address, city, stateName, postalCode].filter(Boolean).join(', ')
  const geocoded = await geocodeAddress(fullAddress)
  if (!geocoded) {
    showCheckoutError('No pudimos encontrar esa dirección. Revisa que esté completa y correcta.')
    return false
  }

  if (geocoded.postalCode && geocoded.postalCode !== postalCode) {
    showCheckoutError(`El código postal no corresponde con la dirección. Google sugiere ${geocoded.postalCode}.`)
    return false
  }
  if (geocoded.city && normalizeText(geocoded.city) !== normalizeText(city)) {
    showCheckoutError(`La ciudad no corresponde con la dirección. Google sugiere "${geocoded.city}".`)
    return false
  }
  if (geocoded.state && normalizeText(geocoded.state) !== normalizeText(stateName)) {
    showCheckoutError(`El estado no corresponde con la dirección. Google sugiere "${geocoded.state}".`)
    return false
  }

  const res = await fetch(`${BACKEND_URL}/api/check-coverage`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lat: geocoded.lat, lng: geocoded.lng }),
  })
  const coverage = await res.json()

  if (!coverage.inCoverage) {
    showCheckoutError('La dirección ingresada está fuera de nuestra zona de cobertura (CDMX y área metropolitana). Regresa al mapa o ajusta los datos.')
    return false
  }

  state.lat     = geocoded.lat
  state.lng     = geocoded.lng
  state.zone    = coverage.zone
  state.address = geocoded.formattedAddress || state.address
  return true
}

// Toggle de edición manual de dirección
document.getElementById('co-edit-address')?.addEventListener('change', (e) => {
  const enabled = e.target.checked
  const ids = ['co-address', 'co-city', 'co-state', 'co-cp']
  ids.forEach((id) => {
    const el = document.getElementById(id)
    if (el) el.disabled = !enabled
  })
  if (!enabled) {
    // Restaurar valores del mapa al deshabilitar
    const { street, neighborhood, city, stateName, postalCode } = state.addressComponents
    document.getElementById('co-address').value = [street, neighborhood].filter(Boolean).join(', ') || state.address || ''
    document.getElementById('co-city').value    = city       || ''
    document.getElementById('co-state').value   = stateName  || ''
    document.getElementById('co-cp').value      = postalCode || ''
    state.initialCheckoutAddress = getCheckoutAddressKey()
    hideCheckoutError()
  }
})

document.getElementById('co-phone')?.addEventListener('input', (e) => {
  const digits = e.target.value.replace(/\D/g, '')
  const isValid = digits.length === 10
  e.target.classList.toggle('input-error', e.target.value !== '' && !isValid)
  const errorEl = document.getElementById('co-phone-error')
  if (errorEl) errorEl.classList.toggle('pureit-hidden', isValid || e.target.value === '')
})

// ─── Paso 4: guardar lead y avanzar al pago ──────────────────────────────────

document.getElementById('form-checkout')?.addEventListener('submit', async (e) => {
  e.preventDefault()
  hideCheckoutError()
  const btn = e.submitter

  // Si el usuario editó la dirección pre-llenada, re-geocodear y reverificar cobertura.
  const addressChanged = getCheckoutAddressKey() !== state.initialCheckoutAddress
  if (addressChanged) {
    setLoading(btn, true, 'Verificando dirección...')
    const valid = await revalidateCheckoutAddress()
    if (!valid) {
      setLoading(btn, false)
      return
    }
  }

  setLoading(btn, true, 'Guardando registro...')

  const customer = {
    name:     document.getElementById('co-name').value.trim(),
    lastName: document.getElementById('co-lastname').value.trim(),
    email:    document.getElementById('co-email').value.trim(),
    phone:    document.getElementById('co-phone').value.trim(),
    address:  document.getElementById('co-address').value.trim(),
    city:     document.getElementById('co-city').value.trim(),
    stateName: document.getElementById('co-state').value.trim(),
    postalCode: document.getElementById('co-cp').value.trim(),
  }

  try {
    const res = await fetch(`${BACKEND_URL}/api/leads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name:    `${customer.name} ${customer.lastName}`,
        email:   customer.email,
        phone:   customer.phone,
        address: state.address,
        lat:     state.lat,
        lng:     state.lng,
        zone:    state.zone,
        quizAnswers: state.lastAnswers || [],
        suggestedProduct: state.suggestedProduct,
        ...(state.accountData?.shopifyCustomerId
          ? { shopifyCustomerId: state.accountData.shopifyCustomerId }
          : {}),
      }),
    })

    if (!res.ok) {
      alert('Hubo un error al guardar tu registro. Intenta de nuevo.')
      return
    }

    const data = await res.json()
    state.leadId = data?.metaobjectCreate?.metaobject?.id || data?.id || null
    state.customer = customer

    document.getElementById('pay-product-name').textContent = state.suggestedProductName || ''
    const payPriceEl = document.getElementById('pay-product-price')
    if (payPriceEl) payPriceEl.textContent = state.suggestedProductPrice ? formatMoney(state.suggestedProductPrice) : ''
    showStep('step-5')
  } finally {
    setLoading(btn, false)
  }
})

// ─── Paso 5: tokenizar tarjeta y crear suscripción ──────────────────────────

function showPaymentError(msg) {
  const box = document.getElementById('payment-error')
  document.getElementById('payment-error-msg').textContent = msg
  box.classList.remove('pureit-hidden')
}

function hidePaymentError() {
  document.getElementById('payment-error').classList.add('pureit-hidden')
}

function tokenizeCard(cardData) {
  return new Promise((resolve, reject) => {
    OpenPay.token.create(cardData, (response) => resolve(response.data.id), (err) => reject(err))
  })
}

document.getElementById('terms-checkbox')?.addEventListener('change', (e) => {
  const btn = document.getElementById('btn-pay')
  if (btn) btn.disabled = !e.target.checked
})

document.getElementById('form-payment')?.addEventListener('submit', async (e) => {
  e.preventDefault()
  hidePaymentError()
  const btn = e.submitter

  if (!document.getElementById('terms-checkbox')?.checked) {
    showPaymentError('Debes aceptar los Términos y condiciones para continuar.')
    return
  }

  if (!initOpenPay()) {
    showPaymentError(PAYMENT_ERROR_MSG)
    return
  }

  // Preferir el planId del catálogo dinámico (admin); caer a settings de la sección si no existe.
  const product = findProduct(state.suggestedProduct)
  const planId = (product && product.planId) || (OPENPAY_CONFIG.plans || {})[state.suggestedProduct]
  if (!planId) {
    showPaymentError(PAYMENT_ERROR_MSG)
    return
  }

  const cardData = {
    card_number:      document.getElementById('card-number').value.replace(/\s+/g, ''),
    holder_name:      document.getElementById('card-holder').value.trim(),
    expiration_year:  document.getElementById('card-year').value.trim(),
    expiration_month: document.getElementById('card-month').value.trim(),
    cvv2:             document.getElementById('card-cvv').value.trim(),
  }

  const validationError = validateCardClientSide(cardData)
  if (validationError) {
    showPaymentError(validationError)
    return
  }

  setLoading(btn, true, 'Procesando pago...')

  try {
    const tokenId = await tokenizeCard(cardData)

    const c = state.customer || {}
    const res = await fetch(`${BACKEND_URL}/api/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name:     c.name,
        lastName: c.lastName,
        email:    c.email,
        phone:    c.phone,
        address: {
          line1:      c.address,
          city:       c.city,
          state:      c.stateName,
          postalCode: c.postalCode,
        },
        planId,
        tokenId,
        leadId: state.leadId,
        deviceSessionId: state.deviceSessionId,
      }),
    })

    const data = await res.json().catch(() => ({}))

    if (!res.ok || !data.success) {
      showPaymentError(PAYMENT_ERROR_MSG)
      return
    }

    document.getElementById('form-payment').classList.add('pureit-hidden')
    document.getElementById('payment-success').classList.remove('pureit-hidden')
    setTimeout(() => { window.location.href = '/account' }, 3000)
  } catch (err) {
    const code = err?.data?.error_code
    const msg = OPENPAY_ERRORS[code] || err?.data?.description || err?.message || 'Error al validar la tarjeta. Revisa los datos e intenta de nuevo.'
    showPaymentError(msg)
  } finally {
    setLoading(btn, false)
  }
})

// ─── Helpers ──────────────────────────────────────────────────────────────────

function showStep(stepId) {
  document.querySelectorAll('.pureit-step').forEach((el) => {
    el.classList.add('pureit-hidden')
  })
  document.getElementById(stepId).classList.remove('pureit-hidden')
}

// Botones "atrás": data-back="step-X"
document.querySelectorAll('.pureit-btn-back').forEach((btn) => {
  btn.addEventListener('click', () => {
    const target = btn.dataset.back
    if (target) showStep(target)
  })
})

// ─── Carga dinámica de Google Maps ───────────────────────────────────────────
;(function () {
  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_KEY}&libraries=places,marker&loading=async&callback=initMap`
  script.defer = true
  script.onerror = mapLoadError
  document.head.appendChild(script)
})()

// ─── Bootstrap: hidratar quiz, productos y notify desde el backend ──────────
loadFormConfig()
